(function () {
  'use strict';
  try {
    if (window.__eyebuddyOpenAIAds) return;
    var element = document.getElementById('eyebuddy-openai-ads-config');
    if (!element) return;
    var config = JSON.parse(element.textContent);
    // Do not silently attach events to an unrelated existing pixel.
    if (window.oaiq) return;
    window.__eyebuddyOpenAIAds = true;
    var q = function () { q.q.push(arguments); };
    q.q = [];
    window.oaiq = q;
    q('consent', false);
    q('init', { pixelId: config.pixelId });
    var sdk = document.createElement('script');
    sdk.async = true;
    sdk.src = 'https://bzrcdn.openai.com/sdk/oaiq.min.js';
    document.head.appendChild(sdk);
    var permitted = false;
    var viewsSent = false;

    function measure(name, data) {
      try {
        if (!permitted) return;
        window.oaiq('measure', name, data, { opt_out: false });
      } catch (_) {}
    }

    function syncConsent() {
      try {
        var privacy = window.Shopify && window.Shopify.customerPrivacy;
        permitted = !!(privacy && privacy.analyticsProcessingAllowed()
          && privacy.marketingAllowed() && privacy.saleOfDataAllowed());
        window.oaiq('consent', permitted);
        if (!permitted) return;
        if (config.emailHash) window.oaiq('init', { user: { email_sha256: config.emailHash } });
        if (viewsSent) return;
        viewsSent = true;
        measure('page_viewed', { type: 'contents', contents: [{
          id: location.pathname, name: document.title, content_type: 'page'
        }] });
        if (config.product) measure('contents_viewed', {
          type: 'contents', currency: config.currency, contents: [config.product]
        });
      } catch (_) { permitted = false; }
    }

    document.addEventListener('visitorConsentCollected', syncConsent);
    if (window.Shopify && window.Shopify.customerPrivacy) syncConsent();
    else if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }],
        function (error) { if (!error) syncConsent(); });
    }

    function requestedQuantities(body) {
      var quantities = {};
      var data;
      if (typeof body === 'string') {
        try { data = JSON.parse(body); } catch (_) { body = new URLSearchParams(body); }
      }
      if (body && typeof body.get === 'function') {
        data = { id: body.get('id'), quantity: body.get('quantity') || 1 };
      }
      if (!data) return quantities;
      (data.items || [data]).forEach(function (item) {
        var quantity = Number(item.quantity == null ? 1 : item.quantity);
        if (item.id && Number.isInteger(quantity) && quantity > 0) {
          quantities[String(item.id)] = (quantities[String(item.id)] || 0) + quantity;
        }
      });
      return quantities;
    }

    var originalFetch = window.fetch;
    if (typeof originalFetch === 'function') window.fetch = function () {
      var args = arguments;
      var promise = originalFetch.apply(this, args);
      // All measurement work is separate from the returned business promise.
      try {
        var request = args[0];
        var options = args[1] || {};
        var url = new URL(typeof request === 'string' || request instanceof URL ? request : request.url, location.href);
        var method = String(options.method || request.method || 'GET').toUpperCase();
        if (url.origin !== location.origin || method !== 'POST' || !/\/cart\/add(?:\.js)?$/.test(url.pathname)) return promise;
        var quantitiesPromise = options.body !== undefined
          ? Promise.resolve(requestedQuantities(options.body))
          : request && typeof request.clone === 'function'
            ? request.clone().text().then(requestedQuantities).catch(function () { return {}; })
            : Promise.resolve({});
        var allowedAtRequest = permitted;
        promise.then(function (response) {
          if (!response.ok || !allowedAtRequest || !permitted) return;
          return Promise.all([response.clone().json(), quantitiesPromise]).then(function (values) {
            var payload = values[0];
            var quantities = values[1];
            var used = {};
            var contents = (payload.items || [payload]).map(function (line) {
              var id = String(line.variant_id || line.id || '');
              var quantity = quantities[id];
              if (!quantity || used[id]) return null;
              used[id] = true;
              return { id: 'shopify-variant-' + id, name: line.product_title || line.title,
                content_type: 'product', quantity: quantity,
                amount: Number(line.final_price == null ? line.price : line.final_price), currency: config.currency };
            }).filter(Boolean);
            if (contents.length) measure('items_added', {
              type: 'contents', currency: config.currency,
              amount: contents.reduce(function (total, item) { return total + item.amount * item.quantity; }, 0),
              contents: contents
            });
          });
        }).catch(function () {});
      } catch (_) {}
      return promise;
    };
  } catch (_) {}
})();
